export default __webpack_public_path__ + "static/bree-serif-v10-latin-regular-b5b3971760510514cb270f5427f3ec6f.woff2";